import { render } from "./ProjectReportsSection.vue?vue&type=template&id=190ad5a2&scoped=true&ts=true"
import script from "./ProjectReportsSection.vue?vue&type=script&lang=ts"
export * from "./ProjectReportsSection.vue?vue&type=script&lang=ts"

import "./ProjectReportsSection.vue?vue&type=style&index=0&id=190ad5a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190ad5a2"]])

export default __exports__